// extracted by mini-css-extract-plugin
export var btnSolidBlue = "GeneralFormStyles-module--btnSolidBlue--add69";
export var checkboxLabel = "GeneralFormStyles-module--checkboxLabel--814e9";
export var error = "GeneralFormStyles-module--error--46e99";
export var formCheckbox = "GeneralFormStyles-module--formCheckbox--fb29f";
export var formInput = "GeneralFormStyles-module--formInput--b30bb";
export var formInputCheckbox = "GeneralFormStyles-module--formInputCheckbox--fdd07";
export var formWrapper = "GeneralFormStyles-module--formWrapper--3a3dc";
export var hidden = "GeneralFormStyles-module--hidden--7cea7";
export var otherText = "GeneralFormStyles-module--otherText--4190a";
export var success = "GeneralFormStyles-module--success--49f84";
export var textGreen = "GeneralFormStyles-module--textGreen--f44ac";